import React from 'react';
import {
  Button,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import SVGBackArrow2 from '@assets/SVGBackArrow2';
import SVGNormalNext from '@assets/SVGNormalNext';
import RenderIf from '@components/RenderIf';
import SVGPressEnter from '@assets/SVGPressEnter';
import useStyles from './styles';
import { SvgBackArrow } from '@assets/SvgBackArrow';

interface FooterStepsProps {
  next?: (event: any) => void;
  back?: (event: any) => void;
  available: boolean;
  position?: number;
}

const FooterSteps = ({ back, available, position = 0 }: FooterStepsProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const numberOfSteps = 4;
  const classes = useStyles();

  return (
    <Grid container direction="row" justify="space-between" alignItems="center">
      <RenderIf condition={position <= numberOfSteps || isMobile}>
        <>
          <Grid item className={classes.backContainer}>
            <Button
              className={classes.backButton}
              size="large"
              variant="outlined"
              color="primary"
              onClick={back}
            >
              <SvgBackArrow color="#6140FF" width='22' height='18'/>
              {/* <SVGNormalNext color='#6140FF' /> */}
            </Button>
            <RenderIf condition={position <= numberOfSteps}>
              <Typography className={classes.smoothText} component="span">
                {position} of {numberOfSteps} questions
              </Typography>
            </RenderIf>
            <RenderIf condition={position > numberOfSteps}>
              <Typography className={classes.smoothText} component="span">
                Enter email to generate script
              </Typography>
            </RenderIf>
          </Grid>
          <Grid item>
            <RenderIf condition={!isMobile}>
              <div className={classes.pressEnter}>
                <SVGPressEnter />
              </div>
            </RenderIf>
            <Button
              type="submit"
              className={classes.button}
              size="large"
              variant="contained"
              color="primary"
              disabled={available}
            >
              <RenderIf condition={!isMobile}>
                <span>Next Question </span>
              </RenderIf>
              <SVGNormalNext color={!available ? 'white' : '#00000042'} />
            </Button>
          </Grid>
        </>
      </RenderIf>
      <RenderIf condition={position > numberOfSteps && !isMobile}>
        <>
          <Grid item>
            <Button
              className={classes.backButton}
              size="large"
              variant="outlined"
              color="primary"
              onClick={back}
            >
              <SVGBackArrow2 color="#6140FF" opacity="1" />
            </Button>
          </Grid>
          <Grid item className={classes.itemGrow}>
            <Button
              type="submit"
              fullWidth
              className={classes.buttonLastStep}
              size="large"
              variant="contained"
              color="primary"
              value="Submit"
              disabled={available}
            >
              Generate Video Script{' '}
              <SVGNormalNext color={!available ? 'white' : '#00000042'} />
            </Button>
          </Grid>
        </>
      </RenderIf>
    </Grid>
  );
};

export default FooterSteps;
